import {
    locationChangedSelector,
    locationSelector
} from '@zoopla/redux-reducer-filters';
import { polyencSelector } from '@zoopla/redux-reducer-search-results';
import { useSelector } from 'react-redux';

const useSearchLocation = (customName = 'Custom area') => {
    const { selectedValue: locationValue } = useSelector(locationSelector);
    const { selectedValue: locationChanged } = useSelector(
        locationChangedSelector
    );

    const polyenc = useSelector(polyencSelector);

    return polyenc && locationChanged === 'false'
        ? customName
        : decodeURIComponent(locationValue);
};

export default useSearchLocation;
